export default function(store, resolveError) {
  return (to, from, next) => {
    let authRequired = false;
    const anonymousRequired = to.matched.some(route => route.meta.anonymous);
    if (!anonymousRequired) {
      authRequired = true;
    }
    if (authRequired) {
      if (store.state.auth.loggedIn) {
        if (store.getters["permission/hasPermission"](to)) {
          next();
        } else {
          resolveError({
            statusCode: 403,
            message: "Permission Denied"
          });
          next();
        }
      } else {
        next("/login");
      }
    } else if (anonymousRequired) {
      if (store.state.auth.loggedIn) {
        next("/");
      } else {
        next();
      }
    } else {
      next();
    }
  };
}
